<div class="dialog-header">
	<div class="header-title">
		<span class="header-span">Dictionary Editor</span>
	</div>

	<div class="buttons-block">
		<button class="header-button send-button" mat-button (click)="saveDict()" [disabled]="saveLoading"
			[ngClass]="{'disabled-button': saveLoading}">
			<span *ngIf="!saveLoading">Save</span>
			<lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
		</button>
	</div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="middle-content">
	<div class="inputs-block">
		<div class="input-block">
			<div class="input-label">Name:</div>

			<div class="email-input-text">
				<input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
					[disabled]="true" [(ngModel)]="tempDict.name">
			</div>
		</div>

		<div class="input-block">
			<div class="input-label">Title:</div>

			<div class="email-input-text">
				<input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
					[disabled]="saveLoading" [(ngModel)]="tempDict.title">
			</div>
		</div>

    <div class="input-block">
      <div class="input-label">Short Title:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
               [disabled]="saveLoading" [(ngModel)]="tempDict.shortTitle">
      </div>
    </div>

		<div class="input-block">
			<div class="input-label">Color:</div>

			<div class="email-input-text color-picker-input">

				<input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation [ngModelOptions]="{standalone: true}"
					[disabled]="saveLoading" [(ngModel)]="tempDict.color">

				<p-colorPicker class="arrow-input" [(ngModel)]="tempDict.color" [disabled]="saveLoading" [inline]="true"
					[ngModelOptions]="{standalone: true}" appendTo="cdk-overlay-container">
				</p-colorPicker>
			</div>
		</div>


	</div>
</div>
